import * as React from 'react';
import { SVGProps } from 'react';

const IconLithologyFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3H2V4Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 9h20v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9Zm3 2h2v2H5v-2Zm5 3H8v2h2v-2Zm3 3h-2v2h2v-2Zm0-6h-2v2h2v-2Zm1 3h2v2h-2v-2Zm5 3h-2v2h2v-2Zm-2-6h2v2h-2v-2ZM7 17H5v2h2v-2Z"
    />
  </svg>
);
export default IconLithologyFilledSizeM;
